module.exports = __webpack_public_path__ + "img/kast.12e8062d.jpg";